
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/understanding-the-different-types-of-business-entities",
      function () {
        return require("private-next-pages/blog/understanding-the-different-types-of-business-entities.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/understanding-the-different-types-of-business-entities"])
      });
    }
  